<!--
 * @Descripttion: s
 * @Author: zhangtingjiang
 * @Date: 2020-01-03 10:28:17
 -->
<template>
  <div
    v-if="copyRight"
    class="container"
  >{{ copyRight }}</div>
</template>
<script>
export default {
  data () {
    return {
      copyRight: process.env.VERSION
    }
  }
}
</script>
<style scoped>
.container {
  padding: 5px 60px;
  text-align: center;
  line-height: 30px;
  color: #fff;
  font-weight: bold;
  background: #c12b20;
  position: fixed;
  font-size: 16px;
  top: 33px;
  z-index: 99999;
}
</style>



// WEBPACK FOOTER //
// src/components/copyRight/CopyRight.vue